export default theme => ({
  loader: {
    display: "block",
    margin: "0 auto",
    color: "#729938",
    width: "80px !important",
    height: "80px !important",
  },
});